import React from "react";
import Logo from "../../images/logo1.png";
import Header from "../../components/layout/header";
import "./LoginPage.scss";

const LoginPage = () => {
  return (
    <>
      <Header />
      <div className="login-container">
        {/* Background Image */}
        <div className="background"></div>

        {/* Login Card */}
        <div className="login-card">
          <div className="logo-container">
            <img src={Logo} alt="Logo" className="logo" />
          </div>
          <h2 className="title">Al Hamd Marine & Trading Portal Login</h2>
          <input
            type="text"
            placeholder="Username or email address"
            className="input-field"
          />
          <button className="login-button">Continue</button>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
